import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_RETURN_SHIPPING, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemReturnShippingMaybe = props => {
  const { lineItems, intl, isProvider } = props;

  const insuranceLineItem = lineItems.find(
    item => item.code === LINE_ITEM_RETURN_SHIPPING && !item.reversal
  );

  return insuranceLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.return_shipping" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, insuranceLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemReturnShippingMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemReturnShippingMaybe;
